import { render } from "./BaseLoader.vue?vue&type=template&id=3f509e26"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\miche\\Documents\\projects\\wiper_frontend_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__